import React from 'react';

const LidarSegmentationIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    {...props}
    style={{ width: '100%', display: 'block' }}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
      fill={props.color || '#29D683'}
    />
    <path
      opacity="0.5"
      d="M30.8269 26.2494V13.7506L20.0001 7.50116L9.17334 13.7506V26.2494L20.0001 32.5035L30.8269 26.2494Z"
      fill="white"
    />
    <path
      opacity="0.5"
      d="M19.9999 15.127C20.8978 15.127 21.6258 14.3991 21.6258 13.5012C21.6258 12.6032 20.8978 11.8753 19.9999 11.8753C19.1019 11.8753 18.374 12.6032 18.374 13.5012C18.374 14.3991 19.1019 15.127 19.9999 15.127Z"
      fill="white"
    />
    <path
      d="M14.3695 18.3741C15.2675 18.3741 15.9954 17.6462 15.9954 16.7483C15.9954 15.8503 15.2675 15.1224 14.3695 15.1224C13.4716 15.1224 12.7437 15.8503 12.7437 16.7483C12.7437 17.6462 13.4716 18.3741 14.3695 18.3741Z"
      fill="white"
    />
    <path
      d="M14.3695 24.8776C15.2675 24.8776 15.9954 24.1497 15.9954 23.2517C15.9954 22.3538 15.2675 21.6259 14.3695 21.6259C13.4716 21.6259 12.7437 22.3538 12.7437 23.2517C12.7437 24.1497 13.4716 24.8776 14.3695 24.8776Z"
      fill="white"
    />
    <path
      opacity="0.5"
      d="M25.6303 18.3741C26.5282 18.3741 27.2561 17.6462 27.2561 16.7483C27.2561 15.8503 26.5282 15.1224 25.6303 15.1224C24.7323 15.1224 24.0044 15.8503 24.0044 16.7483C24.0044 17.6462 24.7323 18.3741 25.6303 18.3741Z"
      fill="white"
    />
    <path
      opacity="0.5"
      d="M19.9999 21.6259C20.8978 21.6259 21.6258 20.898 21.6258 20C21.6258 19.1021 20.8978 18.3741 19.9999 18.3741C19.1019 18.3741 18.374 19.1021 18.374 20C18.374 20.898 19.1019 21.6259 19.9999 21.6259Z"
      fill="white"
    />
    <path
      opacity="0.5"
      d="M25.6303 24.8776C26.5282 24.8776 27.2561 24.1497 27.2561 23.2517C27.2561 22.3538 26.5282 21.6259 25.6303 21.6259C24.7323 21.6259 24.0044 22.3538 24.0044 23.2517C24.0044 24.1497 24.7323 24.8776 25.6303 24.8776Z"
      fill="white"
    />
    <path
      opacity="0.5"
      d="M19.9999 28.1293C20.8978 28.1293 21.6258 27.4014 21.6258 26.5035C21.6258 25.6055 20.8978 24.8776 19.9999 24.8776C19.1019 24.8776 18.374 25.6055 18.374 26.5035C18.374 27.4014 19.1019 28.1293 19.9999 28.1293Z"
      fill="white"
    />
    <path
      opacity="0.5"
      d="M19.9999 15.127C20.8978 15.127 21.6258 14.3991 21.6258 13.5012C21.6258 12.6032 20.8978 11.8753 19.9999 11.8753C19.1019 11.8753 18.374 12.6032 18.374 13.5012C18.374 14.3991 19.1019 15.127 19.9999 15.127Z"
      fill="white"
    />
    <path
      opacity="0.5"
      d="M19.9999 21.6259C20.8978 21.6259 21.6258 20.898 21.6258 20C21.6258 19.1021 20.8978 18.3741 19.9999 18.3741C19.1019 18.3741 18.374 19.1021 18.374 20C18.374 20.898 19.1019 21.6259 19.9999 21.6259Z"
      fill="white"
    />
    <path
      opacity="0.5"
      d="M19.9999 28.1293C20.8978 28.1293 21.6258 27.4014 21.6258 26.5035C21.6258 25.6055 20.8978 24.8776 19.9999 24.8776C19.1019 24.8776 18.374 25.6055 18.374 26.5035C18.374 27.4014 19.1019 28.1293 19.9999 28.1293Z"
      fill="white"
    />
  </svg>
);

export default LidarSegmentationIcon;
